import { Card } from "@overmap-ai/blocks"
import type { ReactNode } from "react"
import { memo } from "react"

import type { ProjectTimelineItemType } from "../../enums/projects"
import { projectTimelineItemTypeData } from "../../mappings/projects"
import { TimelineIconRail } from "../TimelineIconRail/TimelineIconRail"

interface ProjectTimelineCardProps {
	type: ProjectTimelineItemType
	children: ReactNode
}

export const ProjectTimelineCard = memo<ProjectTimelineCardProps>((props) => {
	const { children, type } = props
	const { icon } = projectTimelineItemTypeData[type]

	return (
		<div className="flex h-max w-full gap-4">
			<TimelineIconRail icon={icon} size="sm" />
			<Card className="flex min-w-0 grow flex-col gap-2" size="sm">
				{children}
			</Card>
		</div>
	)
})
ProjectTimelineCard.displayName = "ProjectTimelineCard"
